import type { ThemeType } from "@evidenceb/athena-common/modules/Theme";
import { useContext } from "react";
import { sessionStore } from "../contexts/SessionContext";

const useTheme = (): ThemeType => {
  const {
    session: { theme },
  } = useContext(sessionStore);

  return theme;
};
export default useTheme;
